import React from 'react';
import {listenValue} from './value.js';
import {intlShape} from 'react-intl';
import messages from './globallocales.js';
import {reisy, use} from 'reisy';
import PropTypes from 'prop-types';
import Heading from './heading';

export const styles = reisy`
@namespace Aside;

aside {
	position: fixed;
	position: sticky;
	top: 7em;
	height: 1em;
	left: 1em;
	max-width: 17em;
	opacity: 0;
	white-space: normal;
	word-wrap: break-word;
	transition: opacity $Consts.Transition;
	@media only all and (max-width: 1150px) {
		display: none;
	}
}
asideHeading {
	margin: 0;
	font: bold 2.5em $Fonts.title;
	line-height: 1em;
}
asideSubHeading {
	margin: 0;
	font: normal 1em $Fonts.subtitle;
}
`;

const Aside = ({publisher, show}, {intl: {formatMessage}}) => (
	<aside {...use([styles.aside, show ? {opacity: 1, zIndex: 1} : null])}>
		<Heading lvl={2} {...use(styles.asideHeading)}>{publisher.name}</Heading>
		{publisher.slogan ? <p {...use(styles.asideSubHeading)}>{publisher.slogan}</p> : null}
	</aside>
);

Aside.propTypes = {
	publisher: PropTypes.object.isRequired,
	show: PropTypes.bool
};
Aside.contextTypes = {
	intl: intlShape,
};

export default listenValue(Aside, 'show');



// WEBPACK FOOTER //
// ./lib/components/aside.js